/**
 * 게임 기본 값
 */

export const LAYOUT = {
  BASE_VERTICAL_HEIGHT: 1536,
}

export const ANSWER = {
  EVENT_TYPE: 'answer',
}

export const MODE = {
  BEGINNER: 'beginner',
  INTERMEDIATE: 'intermediate',
  ADVANCED: 'advanced',
}

export const GAME = {
  JONGROGU: 'JONGROGU',
  NONGHYUP: 'NONGHYUP',
  BURGERKING: 'BURGERKING',
  LOTTERIA: 'LOTTERIA',
}

export const ASSIST = {
  START: 'START',
  SHOW: 'SHOW',
  HIDE: 'HIDE',
}

export const EVENT = {
  // DOCUMENT
  DOCUMENT_READY: 'document:ready',

  // STATUS
  PLAY_STATUS_READY: 'play:status:ready',
  PLAY_STATUS_START: 'play:status:start',
  PLAY_STATUS_COMPLETE: 'play:status:complete',

  // STAGE
  PLAY_CHANGE_SCENE: 'play:change:scene',
  PLAY_SCENE_ACTIVE: 'play:scene:active',
  PLAY_GAME_READY: 'play:game:ready',
  PLAY_SCENE_PREV: 'play:scene:prev',
  PLAY_SCENE_NEXT: 'play:scene:next',
  PLAY_SCENE_MOVE: 'play:scene:move',

  // STATUSBAR
  STATUSBAR_CHANGE_TEXT: 'statusbar:change:text',

  // EventObserver
  OBSERVER_CAPTURE: 'observer:capture',
  OBSERVER_CAPTURE_INSIDE: 'observer:capture:inside',
}

export const PLAY_STATUS = {
  READY: 0,
  START: 1,
  COMPLETE: 2,
}

export const PLAY_TIMER = {
  START: 'timer:start',
  END: 'timer:end',
}
